import { ButtonOutlinedSmall } from '@/components/Button';
import { capitalize } from '@/utils/capitalize.ts';

const CONNECTION_ERROR = /timeout|network error|failed to fetch|econnaborted/i;

const errorText = (error: string | null) => {
  if (!error || CONNECTION_ERROR.test(error)) {
    return 'Couldn’t load this page. Please check your connection and try again.';
  }
  return capitalize(error);
};

const ErrorPage = ({
  error,
  onRetry,
  className,
}: {
  error: string | null;
  onRetry?: () => void;
  className?: string;
}) => (
  <div
    className={className}
    style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 10,
      textAlign: 'center',
    }}
    role="alert"
  >
    <p style={{ color: 'red' }}>{errorText(error)}</p>
    <ButtonOutlinedSmall onClick={onRetry ?? (() => window.location.reload())}>
      Try Again
    </ButtonOutlinedSmall>
  </div>
);

export default ErrorPage;
